import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Text, TextProps } from '../../typography';
import DevelopmentContent, { DevelopmentSection } from './DevelopmentContent.pn';
import { DevUnorderdList } from './DevelopmentContent.style.pn';

interface LongridgeContentProps {}

const LongridgeContent: React.FC<LongridgeContentProps> = () => {
  const theme = useTheme();

  const textProps = useMemo(() => {
    const p: TextProps = {
      fontSize: 17,
      lineHeight: 25,
      mt: 8,
      mb: 16,
      color: theme.textDark,
    };
    return p;
  }, [theme]);

  return (
    <div data-testid="longridge-content">
      <DevelopmentContent bg="#fce9f2">
        <DevelopmentSection narrow>
          <iframe
            title="Development Video"
            width="100%"
            height="298px"
            src="https://www.youtube.com/embed/po2TNZ3KDs0?rel=0&modestbranding=1&autohide=1&showinfo=0"
            frameBorder="0"
            allowFullScreen
          />
          <div className="u-marg-bottom">
            <Text {...textProps}>
              Longridge at The Hollows is a quality turnkey development offering new build homes finished to the highest
              standard. A beautiful development of spacious detached and semi detached designs. Longridge offers buyers
              the opportunity to own their own stylish homes in this sought after location on the periphery of Lurgan.
            </Text>
            <Text {...textProps}>
              This exclusive location allows for ease of access to local schools, shops and neighbouring towns whilst
              offering buyers comtemporary and stylish turnkey homes built with traditional craftsmanship.
            </Text>
            <Text {...textProps}>
              <strong>SPECIFICATION</strong>:
            </Text>
            <Text {...textProps}>
              <strong>Kitchens &amp; Utility Rooms</strong>
            </Text>
            <DevUnorderdList {...textProps}>
              <li>High quality units with choice of door, worktop and handle</li>
              <li>
                Integrated appliances to include gas hob, electric oven, extractor hood, fridge/freezer&nbsp; and
                dishwasher
              </li>
              <li>Integrated washing machine where no utility room</li>
              <li>LED lighting to underside of kitchen units&nbsp;</li>
              <li>Recessed down lighters to kitchen ceiling</li>
            </DevUnorderdList>
            <Text {...textProps}>
              <strong>&nbsp;Bathrooms, Ensuites &amp; WCs</strong>
            </Text>
            <DevUnorderdList {...textProps}>
              <li>Contemporary white sanitary ware&nbsp; with chrome fittings</li>
              <li>Shower over bath with screen door</li>
              <li>Separate shower enclosure where applicable&nbsp;</li>
            </DevUnorderdList>
            <Text {...textProps}>
              <strong>Floor Coverings &amp; Tiles</strong>
            </Text>
            <DevUnorderdList {...textProps}>
              <li>Co-ordinated ceramic wall tiling between kitchen units</li>
              <li>Ceramic tiled floor to kitchen/dining area, bathroom,&nbsp; en-suite and WC</li>
              <li>Partial wall tiling to bathroom, en-suite and WC</li>
              <li>Carpets to lounge, bedrooms, hall, stairs and landing</li>
            </DevUnorderdList>
            <Text {...textProps}>
              <strong>Internal Features</strong>
            </Text>
            <DevUnorderdList {...textProps}>
              <li>Internal décor, walls and ceilings painted&nbsp; 1 colour from palette of colours</li>
              <li>Multi fuel Stove with hearth</li>
              <li>Mains supply smoke detectors</li>
              <li>Mains supply Carbon monoxide detectors</li>
              <li>Moulded skirting and architraves</li>
              <li>Painted internal doors with quality ironmongery</li>
              <li>Comprehensive range of electrical sockets,&nbsp; switches, TV and telephone points</li>
              <li>Wiring for future satellite point</li>
              <li>Gas fired central heating system</li>
              <li>Integral Alarm System</li>
            </DevUnorderdList>
            <Text {...textProps}>
              <strong>External Features</strong>
            </Text>
            <DevUnorderdList {...textProps}>
              <li>
                Soft landscaping to front gardens (where applicable)&nbsp; in line with our landscape plan. Planting to
                be carried&nbsp; out Spring/Summer.
              </li>
              <li>Rear gardens rotavated and seeded</li>
              <li>Bitmac driveway</li>
              <li>uPVC double glazed windows with lockable system</li>
              <li>Composite front doors with painted finish</li>
              <li>Outside water tap</li>
              <li>Boundary fencing to side and rear</li>
              <li>Feature external lighting to front and rear doors</li>
              <li>10 year structural warranty</li>
            </DevUnorderdList>
          </div>
        </DevelopmentSection>
      </DevelopmentContent>
    </div>
  );
};

export default LongridgeContent;
